import React from 'react';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'

const PaymentIcon = ({payment}) => {
  return payment ? <CheckOutlined style={{color: 'green'}}/> : <CloseOutlined style={{color: 'red'}}/>
}

export default PaymentIcon;